(() => {
  'use strict';
  if (window.dizaneVideoStoriesReady) return;
  window.dizaneVideoStoriesReady = true;

  const videoSelector = '[data-dizane-videos] .dvs-card__video';

  function showError(video) {
    const card = video.closest('[data-video-card]');
    if (!card) return;
    const play = card.querySelector('[data-video-play]');
    const status = card.querySelector('[data-video-status]');
    const fallback = card.querySelector('[data-video-fallback]');
    video.pause();
    video.hidden = true;
    play.hidden = false;
    play.removeAttribute('aria-busy');
    play.querySelector('.dvs-card__play-text').textContent = 'Réessayer la vidéo';
    status.textContent = 'La vidéo ne démarre pas. Vous pouvez réessayer ou l’ouvrir directement.';
    fallback.hidden = false;
    if (document.activeElement === video) play.focus({ preventScroll: true });
  }

  document.addEventListener('click', (event) => {
    const play = event.target.closest('[data-dizane-videos] [data-video-play]');
    if (!play || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const card = play.closest('[data-video-card]');
    const video = card.querySelector('.dvs-card__video');
    if (!video || !video.dataset.videoSrc) return;
    event.preventDefault();
    if (play.getAttribute('aria-busy') === 'true') return;

    card.querySelector('[data-video-status]').textContent = '';
    card.querySelector('[data-video-fallback]').hidden = true;
    play.setAttribute('aria-busy', 'true');
    if (!video.getAttribute('src')) {
      video.src = video.dataset.videoSrc;
      video.querySelectorAll('[data-track-src]').forEach((track) => {
        track.src = track.dataset.trackSrc;
      });
    } else if (video.error) {
      video.load();
    }
    video.hidden = false;
    play.hidden = true;
    video.focus({ preventScroll: true });
    const pending = video.play();
    if (pending && typeof pending.catch === 'function') {
      pending.catch((error) => {
        if (error && error.name === 'AbortError') return;
        if (video.isConnected && !document.hidden) showError(video);
      });
    }
    play.removeAttribute('aria-busy');
  });

  document.addEventListener('play', (event) => {
    const active = event.target;
    if (!active.matches || !active.matches(videoSelector)) return;
    document.querySelectorAll('video').forEach((video) => {
      if (video !== active && !video.paused) video.pause();
    });
  }, true);

  document.addEventListener('error', (event) => {
    const video = event.target;
    if (video.matches && video.matches(videoSelector) && video.getAttribute('src')) showError(video);
  }, true);

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) return;
    document.querySelectorAll(videoSelector).forEach((video) => video.pause());
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(videoSelector).forEach((video) => video.pause());
  });
})();
